import { render, staticRenderFns } from "./AddOn.vue?vue&type=template&id=763dc9b4"
import script from "./AddOn.vue?vue&type=script&lang=js"
export * from "./AddOn.vue?vue&type=script&lang=js"
import style0 from "./AddOn.vue?vue&type=style&index=0&id=763dc9b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports